import React from 'react';

export const ClockIcon = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    fontFamily: 'monospace',
    fontSize: '32px',
    lineHeight: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000'
  }}>
    <pre style={{ margin: 0, padding: 0, lineHeight: '0.85' }}>{`◴`}</pre>
  </div>
);

export const TargetIcon = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="16" fill="none" stroke="#000" strokeWidth="2" opacity="0.15" />
      <circle cx="20" cy="20" r="11" fill="none" stroke="#000" strokeWidth="2" opacity="0.3" />
      <circle cx="20" cy="20" r="6" fill="none" stroke="#000" strokeWidth="2" opacity="0.5" />
      <circle cx="20" cy="20" r="3" fill="#000" />
    </svg>
  </div>
);

export const ChartIcon = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    fontFamily: 'monospace',
    fontSize: '10px',
    lineHeight: '1.1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000',
    letterSpacing: '-1px'
  }}>
    <pre style={{ margin: 0, padding: 0 }}>{`    ╱╲
   ╱  ╲
  ╱ ╱╲ ╲
 ╱ ╱  ╲ ╲
╱ ╱    ╲ ╲`}</pre>
  </div>
);

export const GeometricClock = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="18" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.2" />
      <line x1="20" y1="20" x2="20" y2="8" stroke="#000" strokeWidth="2" strokeLinecap="round" />
      <line x1="20" y1="20" x2="28" y2="20" stroke="#000" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <circle cx="20" cy="20" r="2" fill="#000" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => {
        const rad = (angle - 90) * Math.PI / 180;
        const x = 20 + 16 * Math.cos(rad);
        const y = 20 + 16 * Math.sin(rad);
        return (
          <circle key={i} cx={x} cy={y} r="1" fill="#000" opacity="0.3" />
        );
      })}
    </svg>
  </div>
);

export const GeometricTarget = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      {/* Concentric shapes */}
      <rect x="4" y="4" width="32" height="32" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.15" rx="2" />
      <circle cx="20" cy="20" r="12" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.25" />
      <polygon points="20,10 26,20 20,30 14,20" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.4" />
      <circle cx="20" cy="20" r="4" fill="#000" opacity="0.6" />
    </svg>
  </div>
);

export const GeometricChart = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      {/* Radar/star chart */}
      <polygon 
        points="20,5 30,15 30,25 20,35 10,25 10,15" 
        fill="none" 
        stroke="#000" 
        strokeWidth="1.5" 
        opacity="0.15" 
      />
      <polygon 
        points="20,10 26,17 26,23 20,30 14,23 14,17" 
        fill="none" 
        stroke="#000" 
        strokeWidth="1.5" 
        opacity="0.25" 
      />
      <polygon 
        points="20,8 28,14 27,26 20,32 13,26 12,14" 
        fill="#000" 
        fillOpacity="0.08"
        stroke="#000" 
        strokeWidth="1.5" 
        opacity="0.5" 
      />
      {/* Center lines */}
      <line x1="20" y1="20" x2="20" y2="5" stroke="#000" strokeWidth="0.5" opacity="0.2" />
      <line x1="20" y1="20" x2="30" y2="15" stroke="#000" strokeWidth="0.5" opacity="0.2" />
      <line x1="20" y1="20" x2="30" y2="25" stroke="#000" strokeWidth="0.5" opacity="0.2" />
    </svg>
  </div>
);

export const MinimalClock = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="17" fill="none" stroke="#000" strokeWidth="2" opacity="0.15" />
      <line x1="20" y1="20" x2="20" y2="9" stroke="#000" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="20" y1="20" x2="27" y2="20" stroke="#000" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
      <circle cx="20" cy="20" r="2.5" fill="#000" />
    </svg>
  </div>
);

export const MinimalTarget = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="3" fill="#000" />
      <circle cx="20" cy="20" r="7" fill="none" stroke="#000" strokeWidth="2" opacity="0.5" />
      <circle cx="20" cy="20" r="12" fill="none" stroke="#000" strokeWidth="2" opacity="0.3" />
      <circle cx="20" cy="20" r="17" fill="none" stroke="#000" strokeWidth="2" opacity="0.15" />
    </svg>
  </div>
);

export const MinimalChart = () => (
  <div style={{
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <svg width="40" height="40" viewBox="0 0 40 40">
      {/* Pentagon radar */}
      {[0, 1, 2, 3, 4, 5, 6].map((i) => {
        const angle = (i * Math.PI * 2) / 7 - Math.PI / 2;
        const x = 20 + 17 * Math.cos(angle);
        const y = 20 + 17 * Math.sin(angle);
        return (
          <line key={i} x1="20" y1="20" x2={x} y2={y} stroke="#000" strokeWidth="1" opacity="0.1" />
        );
      })}
      <circle cx="20" cy="20" r="6" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.2" />
      <circle cx="20" cy="20" r="12" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.15" />
      <circle cx="20" cy="20" r="17" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.1" />
      
      {/* Data polygon */}
      <polygon 
        points="20,7 30,12 28,26 20,31 12,24" 
        fill="#000" 
        fillOpacity="0.12"
        stroke="#000" 
        strokeWidth="2" 
      />
    </svg>
  </div>
);

